// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cookie-message{z-index:1;position:absolute;bottom:32px;right:32px}.cookie-message .text{display:inline-block}.cookie-message .acknowledge{margin-left:16px;display:inline-block}", ""]);
// Exports
module.exports = exports;
